import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.colors.background};
     overflow: hidden ;
     
    img {
      height: auto;
      max-width: 100%;
    }
  }
  #root {
    /* width: 95vw; */
    /* height:95vh; */
    

  }
  .sc-dwfUOf {
    display: none;

  }
  .sc-gTgzIj{
    display: none;
  }
  .geGius{
    margin-left:unset;
    max-width:100vw;  
  }
  
  .sc-iNqMTl{
    margin-left: 50px;
  }
`

export default GlobalStyle
